export * from './forgot-password.component';
